export enum TabIdList {
  route = "route",
  details = "details",
}

export const eventDescriptionPlaceholder = "Undefined Event";
